import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { withAccount } from '../../../components/AccountContext';

import { AssessmentConstants } from '../../../shared/Constants';
import SurveyDetailDisplay from './SurveyDetailDisplay';
import { withGrowl } from '../../../components/GrowlNotifications';

const mapStateToProps = (state) => {
  const { translatedTags, locale } = state.i18n;
  return {
    translatedTags,
    locale,
  };
};

class SurveyDetail extends Component {
  addRespondents(lists, respondents) {
    if (lists.length !== 0) {
      lists
        .filter(value => value.status === AssessmentConstants.ASMT_STATUS.SUBMITTED)
        .forEach((value) => {
          respondents.push(value.respondent.id);
        });
    }
  }

  render() {
    const {
      locale, translatedTags, currentAccount, data,
    } = this.props;
    return (
      <SurveyDetailDisplay
        data={data}
        onEditRespondents={this.handleEditRespondents}
        translatedTags={translatedTags}
        currentAccount={currentAccount}
        locale={locale}
      />
    );
  }
}

SurveyDetail.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  translatedTags: PropTypes.arrayOf(PropTypes.any).isRequired,
};

const compositComponent = connect(
  mapStateToProps,
)(SurveyDetail);
export default withRouter(
  withGrowl(
    injectIntl(withAccount(compositComponent)),
  ),
);
